/* TOPページ用 買取実績（コンパクト版）*/
(function(){
  setTimeout(function(){
    var roots = document.querySelectorAll('.pt-pur');
    for(var i = 0; i < roots.length; i++){
      var r = roots[i], l = r.querySelector('.pt-loading');
      if(!l) continue;
      var dbg = (window.Shopify && window.Shopify.designMode) || /[?&]pt_debug=1/.test(location.search);
      var msg = r.getAttribute('data-pt-init')
        ? 'データの取得が終わっていません（通信待ち、またはブロックされている可能性）'
        : 'スクリプトが実行されていません（コンソールのエラーを確認）';
      if(dbg){ l.style.color = '#b23b3b'; l.textContent = '[デバッグ] ' + msg; }
      else { r.classList.add('is-hidden'); }
    }
  }, 8000);
})();

(function(){
  'use strict';

  /* Aucnetの画像サーバーのベースURL（一覧ページと同じ）。
     Aucnet側のドメインやパス構成が変わった場合はここを直してください。 */
  const AUCNET_IMAGE_BASE = 'https://image.brand-auc.com/brand_img/9/SP/';
  /* セリ流れ商品の画像を探すため、何回分まで遡って候補URLを作るか */
  const MAX_ROUND_LOOKBACK = 6;
  /* テーマエディタの設定値が取れない場合（snippet として読み込んだ場合など）の予備URL。
     一覧ページと同じスプレッドシートです。 */
  const DEFAULT_CSV_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQ6be8DJ786ydn9vb9-PC63IOIqNOJVI0MPwUstxMzLI5Xhb7GZysk_J8E92a21ArFXfWv7G4-UmZiB/pub?output=csv';

  const CAT_LABELS = { ring:'リング', necklace:'ネックレス', earring:'ピアス', bracelet:'ブレスレット', charm:'チャーム', other:'その他' };

  /* 画像の読み込み失敗時に、次の候補URLへ切り替える */
  window.ptPurImgError = function(imgEl){
    const raw = imgEl.getAttribute('data-fallback') || '';
    const list = raw ? raw.split('|').filter(Boolean) : [];
    if(list.length){
      const next = list.shift();
      imgEl.setAttribute('data-fallback', list.join('|'));
      imgEl.src = next;
    } else {
      const wrap = imgEl.closest('.pt-img') || imgEl.closest('.pt-modal-image');
      if(wrap) wrap.classList.add('pt-img-fallback');
    }
  };

  /* ---------- CSVパーサー ---------- */
  function parseCSV(text){
    const rows = [];
    let row = [], field = '', inQuotes = false;
    for(let i = 0; i < text.length; i++){
      const c = text[i], next = text[i+1];
      if(inQuotes){
        if(c === '"' && next === '"'){ field += '"'; i++; }
        else if(c === '"'){ inQuotes = false; }
        else { field += c; }
      } else {
        if(c === '"'){ inQuotes = true; }
        else if(c === ','){ row.push(field); field = ''; }
        else if(c === '\n'){ row.push(field); rows.push(row); row = []; field = ''; }
        else if(c === '\r'){ /* skip */ }
        else { field += c; }
      }
    }
    if(field.length || row.length){ row.push(field); rows.push(row); }
    return rows.filter(r => r.length > 1 || (r.length === 1 && r[0].trim() !== ''));
  }

  function rowsToObjects(rows){
    if(!rows.length) return [];
    const header = rows[0].map(h => h.trim());
    return rows.slice(1).map(r => {
      const obj = {};
      header.forEach((h, i) => { obj[h] = (r[i] || '').trim(); });
      return obj;
    });
  }

  /* ---------- 形状 → 内部カテゴリ ---------- */
  const SHAPE_TO_CAT = {
    '指輪': 'ring',
    'リング': 'ring',
    'ネックレス・ペンダント': 'necklace',
    'ネックレス': 'necklace',
    'ペンダント': 'necklace',
    'ピアス': 'earring',
    'イヤリング': 'earring',
    'ブレスレット': 'bracelet',
    'バングル': 'bracelet',
    'チャーム': 'charm',
    'チャーム・トップ': 'charm',
    'ペンダントトップ': 'charm'
  };
  function mapCategory(shape){ return SHAPE_TO_CAT[shape] || 'other'; }

  /* ---------- 商品名などから素材を推測 ---------- */
  const MATERIAL_PATTERNS = [
    { re: /K\s*24|Ｋ\s*２４/i,  value: 'K24'   },
    { re: /K\s*22|Ｋ\s*２２/i,  value: 'K22'   },
    { re: /K\s*20|Ｋ\s*２０/i,  value: 'K20'   },
    { re: /K\s*18|Ｋ\s*１８/i,  value: 'K18'   },
    { re: /K\s*14|Ｋ\s*１４/i,  value: 'K14'   },
    { re: /K\s*10|Ｋ\s*１０/i,  value: 'K10'   },
    { re: /K\s*9(?!\d)|Ｋ\s*９(?!\d)/i, value: 'K9' },
    { re: /Pt\s*1000|Ｐｔ\s*１０００/i, value: 'Pt1000' },
    { re: /Pt\s*950|Ｐｔ\s*９５０/i, value: 'Pt950' },
    { re: /Pt\s*900|Ｐｔ\s*９００/i, value: 'Pt900' },
    { re: /Pt\s*850|Ｐｔ\s*８５０/i, value: 'Pt850' },
    { re: /Pt|Ｐｔ/i, value: 'Pt' },
    { re: /Au|Ａｕ/i, value: 'Au' },
    { re: /750/,  value: 'K18' },
    { re: /585/,  value: 'K14' }
  ];
  function normalizeText(s){
    return (s || '').replace(/[Ａ-Ｚａ-ｚ０-９]/g, ch =>
      String.fromCharCode(ch.charCodeAt(0) - 0xFEE0)
    );
  }

  /* ---------- タイトルから重量・カラット・サイズ等の数値スペックを除去 ---------- */
  function cleanTitle(raw){
    let t = normalizeText(raw || '');
    t = t.replace(/．/g, '.');
    t = t.replace(/(\d)[,，](\d{3})/g, '$1$2');

    t = t.replace(/D計?[\d.]+ct/gi, '');
    t = t.replace(/[\d.]+(?:[／\/][\d.]+)+g?/g, '');
    t = t.replace(/[\d.]+\s*ct/gi, '');
    t = t.replace(/[\d.]+\s*カラット/g, '');
    t = t.replace(/[\d.]+\s*g(?![a-zA-Z])/gi, '');
    t = t.replace(/[\d.]+\s*号/g, '');
    t = t.replace(/[＃#]\s*[\d.]+/g, '');
    t = t.replace(/(全長|チェーン)?約?[\d.]+\s*(cm|ｃｍ|mm|㎜|ミリ)/gi, '');
    t = t.replace(/[\d.]+\s*刻印/g, '');
    t = t.replace(/[\d.]+\s*[%％]/g, '');
    t = t.replace(/D[:：]?\s*[\d.]+/gi, '');
    t = t.replace(/総重量|全長|チェーン約|刻印|サイズ約|約/g, '');
    t = t.replace(/(^|[\s／\/])D(?=[\s／\/]|$)/g, '$1');
    t = t.replace(/[／\/：:]+/g, ' ');
    t = t.replace(/[ 　]+/g, ' ');
    t = t.replace(/^[\s、,，・.]+|[\s、,，・.]+$/g, '');
    return t.trim() || raw;
  }
  function guessMaterial(title, maker){
    const t = normalizeText(title) + ' ' + normalizeText(maker || '');
    for(const p of MATERIAL_PATTERNS){ if(p.re.test(t)) return p.value; }
    return '';
  }

  function makerLabel(raw){
    const t = normalizeText(raw || '').trim();
    if(!t) return 'ノーブランド';
    if(/no\s*brand/i.test(t)) return 'ノーブランド';
    if(/^others?$/i.test(t)) return 'その他ブランド';
    return t;
  }

  /* ---------- 開催日(20260915等) → 2026-09-15 ---------- */
  function normalizeDate(raw){
    const s = (raw || '').replace(/[^\d]/g, '');
    if(s.length === 8) return s.slice(0,4) + '-' + s.slice(4,6) + '-' + s.slice(6,8);
    if(/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
    return raw;
  }

  /* ---------- 受付番号・開催回数 から画像URL候補を複数生成 ---------- */
  function buildImageCandidates(kaisai, uketsuke){
    const digitsOnly = (uketsuke || '').replace(/[^\d]/g, '');
    if(!kaisai || digitsOnly.length < 3) return [];
    const suffix5 = digitsOnly.slice(-5);
    const folder2 = suffix5.slice(0, 3);

    const kaisaiNum = parseInt(kaisai, 10);
    const prefixMatch = uketsuke.match(/^(\d+)-/);
    const prefixNum = prefixMatch ? parseInt(prefixMatch[1], 10) : kaisaiNum;

    let hi = Math.max(kaisaiNum, prefixNum);
    let lo = Math.min(kaisaiNum, prefixNum);
    if(hi - lo > MAX_ROUND_LOOKBACK) lo = hi - MAX_ROUND_LOOKBACK;

    const candidates = [];
    const seen = new Set();
    for(let k = hi; k >= lo; k--){
      if(seen.has(k)) continue;
      seen.add(k);
      candidates.push(AUCNET_IMAGE_BASE.replace(/\/?$/, '/') + k + '/' + folder2 + '/J' + k + '_' + uketsuke + '_01L.jpg');
    }
    return candidates;
  }

  /* ---------- CSV1行 → 表示用アイテム ---------- */
  function rowToItem(row, idx){
    const title    = row['商品名'] || '';
    const maker    = row['メーカー'] || '';
    const shape    = row['形状'] || '';
    const priceStr = (row['結果価格'] || '0').replace(/[^\d]/g, '');
    const price    = parseInt(priceStr, 10) || 0;
    const date     = normalizeDate(row['開催日']);
    const kaisai   = (row['開催回数'] || '').trim();
    const uketsuke = (row['受付番号'] || '').trim();
    const rating   = (row['総合評価'] || '').trim();
    const material = guessMaterial(title, maker);
    const makerName = makerLabel(maker);

    const tags = [];
    if(material) tags.push(material);
    if(shape) tags.push(shape);

    const imgCandidates = buildImageCandidates(kaisai, uketsuke);

    return {
      id: uketsuke || ('row-' + idx),
      title: cleanTitle(title),
      type: mapCategory(shape),
      material: material,
      maker: makerName,
      price: price,
      date: date,
      rating: rating,
      imgCandidates: imgCandidates,
      img: imgCandidates[0] || '',
      tags: tags
    };
  }

  function esc(s){
    return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
  }
  function isNew(item){ return item.date && (Date.now() - new Date(item.date).getTime()) / 86400000 <= 7; }

  function buildCardHTML(p){
    const cands = p.imgCandidates && p.imgCandidates.length ? p.imgCandidates : (p.img ? [p.img] : []);
    const first = cands[0] || '';
    const rest = cands.slice(1).join('|');
    const img = first
      ? '<img src="'+esc(first)+'" data-fallback="'+esc(rest)+'" alt="'+esc(p.title)+'" loading="lazy" onerror="ptPurImgError(this)">'
      : '<div class="pt-img-fallback-icon">写真準備中</div>';
    const nw  = isNew(p) ? '<span class="pt-badge-new">NEW</span>' : '';
    const wm  = '<span class="pt-watermark">買取実績</span>';
    const tags = (p.tags||[]).filter(Boolean).map(t => '<span class="pt-info-tag">'+esc(t)+'</span>').join('');
    const tagsHtml = tags ? '<div class="pt-info-tags">'+tags+'</div>' : '';
    const dateLabel = p.date ? p.date.replace(/-/g,'.') : '';
    const ratingHtml = p.rating ? '<span class="pt-rating-badge">'+esc(p.rating)+'</span>' : '<span></span>';
    const bottomBar = (dateLabel || p.rating)
      ? '<div class="pt-img-bottom">' + ratingHtml + (dateLabel ? '<span class="pt-img-date">' + dateLabel + '</span>' : '<span></span>') + '</div>'
      : '';
    return '<div class="pt-card">' +
             '<div class="pt-img">' + img + wm + nw + bottomBar + '</div>' +
             '<div class="pt-detail">' +
               '<p class="pt-name" title="' + esc(p.title) + '">' + esc(p.title) + '</p>' + tagsHtml +
               '<p class="pt-price"><span class="pt-price-sub">買取価格</span><span class="pt-price-num">' + p.price.toLocaleString() + '</span>円</p>' +
             '</div>' +
           '</div>';
  }

  /* =================================================================
     セクション単位の初期化
     ================================================================= */
  /* =================================================================
     左右ボタン・進捗バー・マウスドラッグ（横スクロールの操作まわり）
     ================================================================= */
  function setupSlider(grid){
    const wrap = document.createElement('div');
    wrap.className = 'pt-slider';
    grid.parentNode.insertBefore(wrap, grid);
    wrap.appendChild(grid);

    const svgL = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 5 8 12 15 19" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const svgR = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 5 16 12 9 19" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    const prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'pt-nav pt-nav-prev';
    prev.setAttribute('aria-label', '前の実績を見る'); prev.innerHTML = svgL;

    const next = document.createElement('button');
    next.type = 'button'; next.className = 'pt-nav pt-nav-next';
    next.setAttribute('aria-label', '次の実績を見る'); next.innerHTML = svgR;

    const track = document.createElement('div');
    track.className = 'pt-progress';
    track.setAttribute('aria-hidden', 'true');
    track.innerHTML = '<span class="pt-progress-bar"></span>';
    const bar = track.firstChild;

    wrap.appendChild(prev);
    wrap.appendChild(next);
    wrap.appendChild(track);

    function update(){
      const max = grid.scrollWidth - grid.clientWidth;
      const scrollable = max > 2;
      wrap.classList.toggle('is-scrollable', scrollable);
      prev.classList.toggle('is-disabled', !scrollable || grid.scrollLeft <= 2);
      next.classList.toggle('is-disabled', !scrollable || grid.scrollLeft >= max - 2);
      if(scrollable){
        bar.style.width = (grid.clientWidth / grid.scrollWidth * 100) + '%';
        bar.style.left  = (grid.scrollLeft / grid.scrollWidth * 100) + '%';
      }
      /* ボタンを写真の縦中央に合わせる */
      const img = grid.querySelector('.pt-img');
      if(img){ const y = (img.offsetHeight / 2) + 'px'; prev.style.top = y; next.style.top = y; }
    }

    /* 1ページぶん（見えているカード枚数）ずつなめらかに移動 */
    function page(dir){
      const first = grid.querySelector('.pt-item');
      if(!first) return;
      const cs  = getComputedStyle(grid);
      const gap = parseFloat(cs.columnGap || cs.gap) || 0;
      const step = first.offsetWidth + gap;
      const perPage = Math.max(1, Math.floor((grid.clientWidth + gap) / step + 0.01));
      grid.scrollBy({ left: dir * step * perPage, behavior: 'smooth' });
    }
    prev.addEventListener('click', () => page(-1));
    next.addEventListener('click', () => page(1));

    grid.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', () => requestAnimationFrame(update));

    /* ---- マウスでつかんで横にドラッグ（PCのみ。タッチは標準のスワイプ） ---- */
    let down = false, moved = false, startX = 0, startLeft = 0, suppressClick = false;
    grid.addEventListener('mousedown', e => {
      if(e.button !== 0) return;
      down = true; moved = false; startX = e.pageX; startLeft = grid.scrollLeft;
    });
    window.addEventListener('mousemove', e => {
      if(!down) return;
      const dx = e.pageX - startX;
      if(!moved && Math.abs(dx) > 5){ moved = true; grid.classList.add('is-dragging'); }
      if(moved){ grid.scrollLeft = startLeft - dx; e.preventDefault(); }
    });
    window.addEventListener('mouseup', () => {
      if(!down) return;
      down = false;
      if(moved){
        grid.classList.remove('is-dragging');     /* スナップが戻り、カードの位置にぴたっと止まる */
        suppressClick = true;                       /* ドラッグ直後のクリックでモーダルが開かないように */
        setTimeout(() => { suppressClick = false; }, 0);
      }
    });
    grid.addEventListener('click', e => {
      if(suppressClick){ e.stopPropagation(); e.preventDefault(); }
    }, true);
    grid.addEventListener('dragstart', e => e.preventDefault());

    return {
      ready(){
        wrap.classList.add('is-ready');
        update();
        requestAnimationFrame(update);
      }
    };
  }

  function initRoot(root){
    if(root.dataset.ptInit) return;
    root.dataset.ptInit = '1';

    const csvUrl  = root.dataset.csv || DEFAULT_CSV_URL;
    const count   = parseInt(root.dataset.count, 10) || 8;
    const sortKey = root.dataset.sort || 'date-desc';

    const grid         = root.querySelector('.pt-grid');
    const modalOverlay = root.querySelector('.pt-modal-overlay');
    const modalClose   = modalOverlay.querySelector('.pt-modal-close');
    const modalImage   = modalOverlay.querySelector('.pt-modal-image');
    const modalDate    = modalOverlay.querySelector('.pt-modal-date');
    const modalTitle   = modalOverlay.querySelector('.pt-modal-title');
    const modalTags    = modalOverlay.querySelector('.pt-modal-tags');
    const modalPrice   = modalOverlay.querySelector('.pt-modal-price .pt-price-num');
    const modalSpecs   = modalOverlay.querySelector('.pt-modal-specs');

    /* 親要素の transform / overflow の影響を受けないよう、モーダルは body 直下へ退避 */
    document.body.appendChild(modalOverlay);

    let shown = [];
    const slider = setupSlider(grid);

    function openModal(item){
      if(!item) return;
      modalImage.className = 'pt-modal-image';
      const ratingHtml = item.rating ? '<span class="pt-rating-badge pt-modal-rating">'+esc(item.rating)+'</span>' : '';
      const cands = item.imgCandidates && item.imgCandidates.length ? item.imgCandidates : (item.img ? [item.img] : []);
      const first = cands[0] || '';
      const rest = cands.slice(1).join('|');
      modalImage.innerHTML = (first
        ? '<img src="'+esc(first)+'" data-fallback="'+esc(rest)+'" alt="'+esc(item.title)+'" onerror="ptPurImgError(this)">'
        : '<div class="pt-img-fallback-icon">写真準備中</div>') + ratingHtml;
      modalDate.textContent = item.date ? item.date.replace(/-/g,'.') : '';
      modalTitle.textContent = item.title;
      modalTags.innerHTML = (item.tags||[]).filter(Boolean).map(t => '<span class="pt-info-tag">'+esc(t)+'</span>').join('');
      modalPrice.textContent = item.price.toLocaleString();

      const specs = [['カテゴリ', CAT_LABELS[item.type] || 'その他']];
      if(item.maker && item.maker !== 'ノーブランド') specs.push(['メーカー', item.maker]);
      if(item.material) specs.push(['素材', item.material]);
      modalSpecs.innerHTML = specs.map(([k,v]) =>
        '<div class="pt-modal-spec-row"><dt>'+esc(k)+'</dt><dd>'+esc(v)+'</dd></div>'
      ).join('');

      modalOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if(modalClose) modalClose.focus();
    }
    function closeModal(){
      if(!modalOverlay.classList.contains('is-open')) return;
      modalOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    modalClose.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', e => { if(e.target === modalOverlay) closeModal(); });
    document.addEventListener('keydown', e => { if(e.key === 'Escape') closeModal(); });

    function pickFromCard(e){
      const card = e.target.closest('.pt-item');
      if(!card) return null;
      return shown[parseInt(card.dataset.idx, 10)] || null;
    }
    grid.addEventListener('click', e => {
      const item = pickFromCard(e);
      if(item) openModal(item);
    });
    grid.addEventListener('keydown', e => {
      if(e.key !== 'Enter' && e.key !== ' ') return;
      const item = pickFromCard(e);
      if(!item) return;
      e.preventDefault();
      openModal(item);
    });

    function hideSection(msg, err){
      if(err) console.error('[top-purchase-records] ' + msg, err);
      else console.warn('[top-purchase-records] ' + msg);
      /* テーマエディタ、または URL の末尾に ?pt_debug=1 を付けた時は、
         非表示にせず原因を画面に出す（公開時は崩れないよう非表示） */
      const debug = (window.Shopify && window.Shopify.designMode) || /[?&]pt_debug=1/.test(location.search);
      if(debug){
        grid.innerHTML = '<p class="pt-loading" style="color:#b23b3b">[デバッグ] ' + esc(msg) + '</p>';
      } else {
        root.classList.add('is-hidden');
      }
    }

    if(!csvUrl || csvUrl.indexOf('http') !== 0){
      hideSection('CSVのURLが設定されていません');
      return;
    }

    fetch(csvUrl, { cache: 'no-store' })
      .then(res => {
        if(!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(text => {
        const items = rowsToObjects(parseCSV(text))
          .map((row, idx) => rowToItem(row, idx))
          .filter(item => item.title);

        const ts = d => Date.parse(d) || 0;
        items.sort((a, b) => sortKey === 'price-desc'
          ? (b.price - a.price) || (ts(b.date) - ts(a.date))
          : (ts(b.date) - ts(a.date)) || (b.price - a.price));

        shown = items.slice(0, count);
        if(!shown.length){ hideSection('表示できる実績がありません'); return; }

        grid.innerHTML = '';
        const frag = document.createDocumentFragment();
        shown.forEach((p, i) => {
          const d = document.createElement('div');
          d.className = 'pt-item';
          d.dataset.idx = i;
          d.tabIndex = 0;
          d.setAttribute('role', 'button');
          d.setAttribute('aria-haspopup', 'dialog');
          d.innerHTML = buildCardHTML(p);
          frag.appendChild(d);
        });
        grid.appendChild(frag);
        slider.ready();
      })
      .catch(err => hideSection('CSV読み込みエラー', err));
  }

  function start(){
    document.querySelectorAll('.pt-pur').forEach(root => {
      try{ initRoot(root); }
      catch(err){ console.error('[top-purchase-records] init error:', err); root.classList.add('is-hidden'); }
    });
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start)
    : start();
})();